import { queryString, } from 'utils/window';
import { isDesktop, isNativeApp, } from 'utils/ua';
import { currentCountryCode, } from 'providers/geolocationProvider';
import { injectElement, logger } from 'application/injectDynamicContent';
import { AD_FORMATS, CLASS_NAMES as AD_CLASS_NAMES, } from 'config/adsConfig';
import { isPostPage, isEmbededPost, isPundit, isTopX, } from 'application/pageDataObject';


const { adsDebugDynamicSlot, } = queryString;
const isNonEmbeddedNonPunditPostPageOnMobile = (isPostPage || isTopX) && !isEmbededPost && !isDesktop && !isPundit;
const DFP_DYNAMIC_SLOT_BLACK_LISTED_COUNTRY_CODES = ['DE', ];
const { BLOCK, EMPTY, INJECTED, DFP, } = AD_CLASS_NAMES;
const INJECTED_ELEMENT_CONF_DFP_SLOT = {
  className: [BLOCK, INJECTED, EMPTY, DFP, ].join(' '),
  dataset: {
    slotId: AD_FORMATS.InArticleDynamic,
  },
};


function isDfpDynamicSlotEnabled(){
  // Unlike in web, in the app we get the cc via the 'countryCode' queryString.
  // That's why currentCountryCode is actually the current countryCode, without fetching.
  if (isNativeApp && DFP_DYNAMIC_SLOT_BLACK_LISTED_COUNTRY_CODES.includes(currentCountryCode)) {
    return false;
  }

  return isNonEmbeddedNonPunditPostPageOnMobile;
}

export function initDfpDynamicSlot(config){
  const dfpLogger = logger.part(adsDebugDynamicSlot, 'dfpDynamicSlot:');
  if (!isDfpDynamicSlotEnabled()) {
    dfpLogger('disabled', { isDfpDynamicSlotEnabled, isNonEmbeddedNonPunditPostPageOnMobile, });
    return false;
  }
  return injectElement(INJECTED_ELEMENT_CONF_DFP_SLOT, dfpLogger);
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/config/adInjectedDfpDynamicSlotConfig.js